<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
      <div class="bg-white page-border">
      <!--page body contant -->
        
        <div class="row row-replace add-m-b">
          <!-- header  -->
          <div class="col-md-6 col-p h5">DASHBOARD / MRF</div>
            <div class="col-md-6 top-corner-items col-p"> 
                <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/addmrf']"> <i class="fa fa-plus"></i>Add MRF</button>
            </div>
       </div>
  
       <div class="row row-replace">
            <!--first card-->
            <div class="col-md-3">
                <div class="card-body card card-animate">
                    <div class="d-flex justify-content-between mb-3">
                        <div>
                            <span class="d-block">Total MRF</span>
                        </div>
                        <div>
                            <span class="text-success">+10%</span>
                        </div>
                    </div>
                    <h3 class="mb-3">112</h3>
                    <div class="progress mb-2" style="height: 5px;">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 70%;" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
            <!--second card-->
            <div class="col-md-3">
                <div class="card-body card card-animate">
                    <div class="d-flex justify-content-between mb-3">
                        <div>
                            <span class="d-block">Total MRF</span>
                        </div>
                        <div>
                            <span class="text-success">+10%</span>
                        </div>
                    </div>
                    <h3 class="mb-3">112</h3>
                    <div class="progress mb-2" style="height: 5px;">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 70%;" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card-body card card-animate">
                    <div class="d-flex justify-content-between mb-3">
                        <div>
                            <span class="d-block">Total MRF</span>
                        </div>
                        <div>
                            <span class="text-success">+10%</span>
                        </div>
                    </div>
                    <h3 class="mb-3">112</h3>
                    <div class="progress mb-2" style="height: 5px;">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 70%;" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
            <!--fourth card-->
            <div class="col-md-3">
                <div class="card-body card card-animate">
                    <div class="d-flex justify-content-between mb-3">
                        <div>
                            <span class="d-block">Total MRF</span>
                        </div>
                        <div>
                            <span class="text-success">+10%</span>
                        </div>
                    </div>
                    <h3 class="mb-3">112</h3>
                    <div class="progress mb-2" style="height: 5px;">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 70%;" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row row-replace">
            <div class="col-12 col-pn">
               <div class="card card-table flex-fill">
                  <div class="card-header">
                     <h3 class="card-title mb-0">MRF</h3>
                  </div>
                  <div class="card-body">
                     <div class="table-responsive">
                        <table class="table custom-table mb-0">
                           <thead>
                              <tr>
                                 <th>MRF ID</th>
                                 <th>Rasied On</th>
                                 <th>Site Name</th>
                                 <th>Employment Category</th>
                                 <th>Designation</th>
                                 <th>No of position	</th>
                                 <th>Pending</th>
                                 <th>Approved</th>
                                 <th>Assigned</th>
                                 <th>Interview In Progress</th>
                                 <th>Offered</th>
                                 <th>Closed</th>
                                 <th>Joined</th>
                                 <th>Re-Open</th>
                                 <th>Rejected</th>
                                 <th>Mrf Not Required</th>
                                 <th>Action</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr>
                                 <td><a [routerLink]="['/dashboard/mrfemployeedetails']">NA001</a></td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>
                                    <div class="dropdown action-label">
                                       <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="javascriptvoid(0);" data-toggle="dropdown" aria-expanded="false">
                                       <i class="fa fa-dot-circle-o text-success"></i> Active
                                       </a>
                                       <div class="dropdown-menu dropdown-menu-right">
                                          <a class="dropdown-item" href="javascriptvoid(0);"><i class="fa fa-dot-circle-o text-success"></i>
                                          Active</a>
                                          <a class="dropdown-item" href="javascriptvoid(0);"><i class="fa fa-dot-circle-o text-danger"></i>
                                          Inactive</a>
                                       </div>
                                    </div>
                                 </td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>NA001</td>
                                 <td>
                                    <div class="dropdown dropdown-action">
                                       <a href="javascriptvoid(0);" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
                                       <div class="dropdown-menu dropdown-menu-right">
                                          <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-pencil m-r-5"></i> Edit</a>
                                          <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  <!-- /organisation Table -->
                  <input type="hidden" id="get_org_routes" value="http://localhost/accesshr/setups/getOrganisations">
               </div>
            </div>
         </div>
         <!--end table -->



<!-- 
         <div class="row row-replace">
            <div class="col-12 col-pn">
               <div class="card card-table flex-fill">
                  <div class="card-header">
                     <h3 class="card-title mb-0">MRF</h3>
                  </div>
                  <div class="card-body">
                     <div class="table-responsive">
                        <table class="table custom-table mb-0">
                            <thead>
                                <tr>
                                  <th scope="col">MRF ID</th>
                                  <th scope="col">Rasied On</th>
                                  <th scope="col">Site Name</th>
                                  <th scope="col">Employment Category</th>
                                  <th scope="col">Designation</th>
                                  <th scope="col">No of position	</th>
                                  <th scope="col">Pending</th>
                                  <th scope="col">Approved</th>
                                  <th scope="col">Assigned</th>
                                  <th scope="col">Interview In Progress</th>
                                  <th scope="col">Offered</th>
                                  <th scope="col">Closed</th>
                                  <th scope="col">Joined</th>
                                  <th scope="col">Re-Open</th>
                                  <th scope="col">Rejected</th>
                                  <th scope="col">Mrf Not Required</th>
                                  <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let country of countries; index as i">
                                  <th scope="row">{{ i + 1 }}</th>
                                  <td>
                                   
                                    {{ country.row2 }}
                                  </td>
                                  <td>{{ country.row3 }}</td>
                                  <td>{{ country.row4}}</td>
                                  <td>{{ country.row5}}</td>
                                  <td>{{ country.row6}}</td>
                                  <td>{{ country.row7}}</td>
                                  <td>{{ country.row8}}</td>
                                  <td>{{ country.row9}}</td>
                                  <td>{{ country.row10}}</td>
                                  <td>{{ country.row11}}</td>
                                  <td>{{ country.row12}}</td>
                                  <td>{{ country.row13}}</td>
                                  <td>{{ country.row14}}</td>
                                  <td>{{ country.row15}}</td>
                                  <td>{{ country.row16}}</td>
                                  <td>{{ country.row17}}</td>
                                </tr>
                                </tbody>
                        </table>
                     </div>
                  </div>
                  
                 <input type="hidden" id="get_org_routes" value="http://localhost/accesshr/setups/getOrganisations">
               </div>
            </div>
         </div>
     --> 
        


       
      <!--end page body contant -->
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  